
import Button from '../base/Button';

export default function VideoFeedback() {
  const handleBuyNow = () => {
    window.open('https://entrega.logzz.com.br/pay/mem6qvd4r/1-kit-com-6-facas-promocao', '_blank');
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
            Feedback de Quem Comprou e Aprovou
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Veja o que nossos clientes estão dizendo sobre o kit
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Primeiro vídeo */}
          <div className="bg-white rounded-2xl p-6 shadow-lg">
            <div className="relative w-full" style={{ paddingBottom: '177.78%' }}>
              <iframe
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                src="https://www.youtube.com/embed/fRfSrLf4Y0Y"
                title="Feedback do Kit de Facas"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
            
            <div className="mt-6 text-center">
              <div className="flex items-center justify-center gap-2 mb-3">
                <div className="flex">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <span className="font-semibold text-gray-800">5.0/5</span>
              </div>
              <p className="text-gray-600">
                Depoimento real de cliente satisfeito
              </p>
            </div>
          </div>

          {/* Segundo vídeo */}
          <div className="bg-white rounded-2xl p-6 shadow-lg">
            <div className="relative w-full" style={{ paddingBottom: '177.78%' }}>
              <iframe
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                src="https://www.youtube.com/embed/xH7vx_JmlOs"
                title="Segundo Feedback do Kit de Facas"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
            
            <div className="mt-6 text-center">
              <div className="flex items-center justify-center gap-2 mb-3">
                <div className="flex">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <span className="font-semibold text-gray-800">5.0/5</span>
              </div>
              <p className="text-gray-600">
                Mais uma cliente satisfeita com a qualidade do nosso Kit Profissional Original.
              </p>
            </div>
          </div>

          {/* Terceiro vídeo */}
          <div className="bg-white rounded-2xl p-6 shadow-lg">
            <div className="relative w-full" style={{ paddingBottom: '177.78%' }}>
              <iframe
                className="absolute top-0 left-0 w-full h-full rounded-lg"
                src="https://www.youtube.com/embed/4FrcVrWIBEo"
                title="Terceiro Feedback do Kit de Facas"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>
            
            <div className="mt-6 text-center">
              <div className="flex items-center justify-center gap-2 mb-3">
                <div className="flex">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <span className="font-semibold text-gray-800">5.0/5</span>
              </div>
              <p className="text-gray-600">
                Cliente aprovando a excelente qualidade das facas
              </p>
            </div>
          </div>
        </div>
        
        {/* Call to Action */}
        <div className="text-center mt-12">
          <p className="text-xl text-gray-700 mb-6">
            Junte-se aos nossos milhares de clientes satisfeitos!
          </p>
          
          <div className="flex justify-center">
            <button 
              onClick={handleBuyNow}
              className="bg-green-600 hover:bg-green-700 text-white font-bold text-lg px-8 py-4 rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap animate-pulse shadow-lg hover:shadow-xl max-w-xs w-full sm:w-auto"
            >
              QUERO APROVEITAR A OFERTA
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
